import styled from "styled-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import { IFontProps } from "@/typings/Props";
import { TEcoSystemGuide } from "@/typings/Props";
import Spot from "./Spot";
import ResultSheetModal from "./ResultSheetModal";

export type TProps = {
  modalImg?: string;
  ecoImg: string;
  title?: string;
  desc?: string;
  ecoSystem: TEcoSystemGuide[] | null;
  isBlock?: boolean;
};

export default function EcoSystem(props: TProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {props.title && (
        <P
          $fontSize="2.6rem"
          $fontWeight={theme.fontWeights.bold}
          $fontColor={theme.colors.text.grayDark}
          $lineHeight="180%"
          $padding="0 90px"
          $margin="70px 0 0 0"
          dangerouslySetInnerHTML={{ __html: t(props.title) }}
          className="eco-title"
        />
      )}
      {props.desc && (
        <P
          $fontColor={theme.colors.text.grayLight}
          $lineHeight="150%"
          $fontSize="1.2rem"
          $padding="0 90px"
          $margin="0 0 60px 0"
          className="eco-desc"
        >
          {props.desc}
        </P>
      )}
      {props.modalImg && (
        <Img id="modalImage" src={props.modalImg} alt="modal-image" onClick={() => setIsModalOpen(true)} />
      )}
      {!props.isBlock && (
        <EcoSystemArea>
          <Area>
            <Img src={props.ecoImg} alt="eco-image" />
            {props.ecoSystem &&
              props.ecoSystem.map((data) => {
                return <Spot key={data.id} {...data} />;
              })}
          </Area>
        </EcoSystemArea>
      )}
      {props.isBlock && (
        <div>
          <img src={props.ecoImg} />
          {props.ecoSystem &&
            props.ecoSystem.map((data) => {
              return <Spot key={data.id} {...data} />;
            })}
        </div>
      )}

      {props.modalImg && (
        <ResultSheetModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} path={props.modalImg} />
      )}
    </>
  );
}

const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  padding: ${(props) => props.$padding};
  margin: ${(props) => props.$margin};
  color: ${(props) => props.$fontColor};
  text-align: center;
  white-space: pre-wrap;
  ${media.tablet`
    margin: 30px 0 0 0;
  `}
`;

const EcoSystemArea = styled.div`
  position: relative;
  margin: 50px 0 0 0;
  width: 100%;
  height: 600px;
  ${media.tablet`
    min-height: 56.25vw;
    height: initial;
  `}
`;
const Area = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  ${media.tablet`
    left: initial;
    transform: initial;
  `}
`;

const Img = styled.img`
  width: 1130px;
  height: auto;
  transition: ease-out 0.3s;
  user-select: none;
  -webkit-user-drag: none;
  &#modalImage {
    width: 933px;
    display: block;
    margin: auto;
    padding: 0 30px;
    cursor: pointer;
  }

  @media (max-width: 1140px) {
    width: 1000px;
  }

  @media (max-width: 1010px) {
    width: 800px;
    &#modalImage {
      width: 600px;
    }
  }
  ${media.tablet`
    width: 100%;
  `}
`;
